module.exports = __webpack_public_path__ + "img/feed_post_btn.df4a6c84.svg";